const GRADE_SLUG = {
	"A+": "a-plus",
	A: "a",
	"A-": "a-minus",
	"B+": "b-plus",
	B: "b",
	"B-": "b-minus",
	"C+": "c-plus",
	C: "c",
	"C-": "c-minus",
	D: "d",
	F: "f",
};

function gradeSlug(grade) {
	return GRADE_SLUG[grade] || "default";
}

export function getGradeGradientClass(grade) {
	return `grade-gradient--${gradeSlug(grade)}`;
}

export function getGradeTextClass(grade) {
	return `grade-text--${gradeSlug(grade)}`;
}

export function getAuditGradePillClass(grade) {
	return `audit-history-grade-pill--${gradeSlug(grade)}`;
}

/** @deprecated use getGradeGradientClass */
export function getGradeColor(grade) {
	return getGradeGradientClass(grade);
}

/** @deprecated use getGradeTextClass */
export function getGradeTextColor(grade) {
	return getGradeTextClass(grade);
}

export function getScoreColorClass(score) {
	if (score >= 95) return "grade-text--a-plus";
	if (score >= 90) return "grade-text--a";
	if (score >= 85) return "grade-text--a-minus";
	if (score >= 80) return "grade-text--b-plus";
	if (score >= 75) return "grade-text--b";
	if (score >= 70) return "grade-text--b-minus";
	if (score >= 65) return "grade-text--c-plus";
	if (score >= 60) return "grade-text--c";
	if (score >= 55) return "grade-text--c-minus";
	if (score >= 50) return "grade-text--d";
	return "grade-text--f";
}

export function getScoreHex(score) {
	if (score >= 80) return "#10b981";
	if (score >= 60) return "#3b82f6";
	if (score >= 40) return "#f59e0b";
	return "#ef4444";
}

export function getSeverityClass(severity) {
	const s = String(severity || "").toLowerCase();
	if (["critical", "high", "medium", "low"].includes(s)) {
		return `severity-badge--${s}`;
	}
	return "severity-badge--default";
}

export function getSeverityBadgeColor(severity) {
	const s = String(severity || "").toLowerCase();
	if (s === "critical") return "destructive";
	if (s === "high") return "warning";
	if (s === "medium") return "info";
	return "secondary";
}
